/**
 * @fileoverview GET handler for the "/engagement/campaigns/experiment_data/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsExperimentDataCampaignId } from "./constants";
import type { EngagementCampaignsExperimentDataCampaignIdResult } from "./types";

export const getEngagementCampaignsExperimentDataCampaignId = reactQueryFetcherAdapter(
  engagementCampaignsExperimentDataCampaignId,
  (
    signal: AbortSignal,
    campaignId: string,
    viewActiveCampaign: boolean
  ): Promise<EngagementCampaignsExperimentDataCampaignIdResult> => {
    return fetch(
      `/engagement/campaigns/experiment_data/${campaignId}`,
      "GET",
      { view_active_campaign: viewActiveCampaign },
      { signal }
    );
  }
);
